import { createSelector } from "reselect";
import get from "lodash/get";
import { guestOrderSelector } from "../guestOrder";
import { ekycSelector } from "../appSettings";
import { kycConfigSelector } from "../ekyc";

const manualEkycFormDomain = state =>
  get(state, "form.ManualEkycForm.values", {});

// ***************************************************************
// ***************** ManualEkycForm selectors ********************
// ***************************************************************
export const manualEkycFormSelector = createSelector(
  manualEkycFormDomain,
  manualEkycForm => manualEkycForm
);

export const manualKycParamsSelector = createSelector(
  manualEkycFormDomain,
  guestOrderSelector,
  kycConfigSelector,
  (form, order, config) => {
    const selectedDocType = form.doc_type?.value;
    const selectedDocument = config[selectedDocType];

    const kycData = {
      orderId: order?.order_ref,
      planType: "Postpaid",
      nationality: form.nationality?.value || "",
      document: {
        type: selectedDocument?.type,
        ...(selectedDocument?.documentNumber?.enabled && {
          documentId: form.document_id
        }),
        ...(selectedDocument?.expiryDate?.enabled && {
          expiryDate: form.document_expiry_date
        })
      }
    };

    return kycData;
  }
);

export const allKycFormFieldAvailableSelector = createSelector(
  manualEkycFormDomain,
  ekycSelector,
  kycConfigSelector,
  (form, ekycSettings, config) => {
    let loading = false;
    const selectedDocType = form?.doc_type?.value;
    const selectedConfig = { ...config[selectedDocType] };

    selectedConfig && delete selectedConfig.type;

    const allRequiredFields = selectedConfig
      ? Object.keys(selectedConfig)?.reduce((prev, curr) => {
          if (selectedConfig[curr].enabled && selectedConfig[curr].required) {
            return [...prev, ekycSettings.keyMap[curr] || curr];
          }
          return prev;
        }, ekycSettings?.manual_ekyc_required_fields || ["nationality", "doc_type", "document_id", "document_expiry_date", "front", "back"])
      : [];

    const requiredFields = [...new Set(allRequiredFields)].filter(val => !!val);

    for (let field of requiredFields) {
      if (!form[field]) {
        loading = true;
        break;
      }
    }

    return loading;
  }
);

// ***************************************************************
// **************** ManualEkycForm makeSelect ********************
// ***************************************************************
export const makeSelectManualEkycForm = () => manualEkycFormSelector;

export const makeSelectManualKycParams = () => manualKycParamsSelector;

export const makeSelectAllKycFormFieldAvailable = () =>
  allKycFormFieldAvailableSelector;
